import { useRef, useState } from "react";
import { uploadImage, imgUrl, errMsg } from "@/lib/api";
import { toast } from "sonner";
import { ImagePlus, Loader2, X } from "lucide-react";

export default function PhotoUploader({ value, onChange, kind = "listing", max = 12, testid = "photo-uploader" }) {
  const input = useRef(null);
  const [busy, setBusy] = useState(false);

  const pick = async (e) => {
    const files = Array.from(e.target.files || []).slice(0, max - value.length);
    e.target.value = "";
    if (!files.length) return;
    setBusy(true);
    try {
      const urls = [];
      for (const f of files) urls.push(await uploadImage(f, kind));
      onChange([...value, ...urls]);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="grid grid-cols-3 gap-3 sm:grid-cols-4" data-testid={testid}>
      {value.map((u, i) => (
        <div key={u} className="group relative aspect-square overflow-hidden rounded-xl border bg-stone-100">
          <img src={imgUrl(u)} alt="" className="h-full w-full object-cover" />
          {i === 0 && kind === "listing" && <span className="absolute bottom-1 left-1 rounded bg-white/90 px-1.5 text-[10px] font-semibold">Cover</span>}
          <button type="button" data-testid={`${testid}-remove-${i}`} onClick={() => onChange(value.filter((x) => x !== u))} className="absolute right-1 top-1 grid h-6 w-6 place-items-center rounded-full bg-white/95 text-stone-700 shadow">
            <X className="h-3.5 w-3.5" />
          </button>
        </div>
      ))}
      {value.length < max && (
        <button type="button" data-testid={`${testid}-add`} disabled={busy} onClick={() => input.current?.click()} className="grid aspect-square place-items-center rounded-xl border-2 border-dashed border-stone-300 text-stone-500 transition-colors hover:border-primary hover:text-primary">
          {busy ? <Loader2 className="h-6 w-6 animate-spin" /> : <span className="flex flex-col items-center gap-1 text-xs"><ImagePlus className="h-6 w-6" />Add photos</span>}
        </button>
      )}
      <input ref={input} type="file" accept="image/*" multiple hidden onChange={pick} data-testid={`${testid}-input`} />
    </div>
  );
}
